/* eslint-disable no-restricted-imports, import/no-dynamic-require */
import { L10nModule } from 'bernie-common';

export const localization = (locale: string): L10nModule => {
  const mod = new L10nModule();

  mod.current = locale;
  mod.globalize = require(`lx-nimble-localization/dist/bundle-${locale}`);

  return mod;
};
